import { render } from "./WalletPayment.vue?vue&type=template&id=c80b1156&scoped=true"
import script from "./WalletPayment.vue?vue&type=script&lang=js"
export * from "./WalletPayment.vue?vue&type=script&lang=js"

import "./WalletPayment.vue?vue&type=style&index=0&id=c80b1156&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80b1156"]])

export default __exports__